import type { LinkComponentProps } from '@cloudflare/kumo';
import { Link } from '@tanstack/react-router';
import { forwardRef } from 'react';

export const AppLink = forwardRef<HTMLAnchorElement, LinkComponentProps>(({ href, to, ...props }, ref) => (
  <Link {...props} ref={ref} to={href ?? to} />
));
